// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.deliveryMethods', {
    url: '/deliverymethods',
    templateUrl: 'main/configuration/deliveryMethods/deliveryMethods.tpl.html',
    data: { pageTitle: 'Delivery methods' },
  });
};

angular.module('configuration.deliveryMethods', []).config(config);
